export default "__VITE_ASSET__CY6ro1Kq__"